import {SELLER_TYPE} from './sellertypes';

const determineIsTrader = (showBrokerInfoDSA, showBrokerInfo, isCMA, isDSA, isDsaAccepted, sellerType) => {
  if (showBrokerInfoDSA) {
    // New logic
    if (showBrokerInfo) {
      // CMA
      if (sellerType === SELLER_TYPE.BUSINESS) {
        return true;
      }

      return isCMA && sellerType === SELLER_TYPE.TRADER;
    }
    // DSA
    if (sellerType === SELLER_TYPE.BUSINESS) {
      return isDsaAccepted;
    }

    if (sellerType === SELLER_TYPE.TRADER) {
      return isDsaAccepted && isDSA;
    }

    return false;
  }

  // Old logic
  return showBrokerInfo && (sellerType === SELLER_TYPE.BUSINESS || sellerType === SELLER_TYPE.TRADER);
};

export {determineIsTrader};
